import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Grid from '../../common/components/Grid'
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import Dialog, {DialogContent, withMobileDialog} from 'material-ui/Dialog'
import Divider from 'material-ui/Divider'
import {Link} from 'react-router-dom'
import IconButton from 'material-ui/IconButton'
import CloseIcon from 'material-ui-icons/Close'
import FacebookLoginButton from 'react-facebook-login'
import LoadingButton from '../../common/components/LoadingButton'

import {login as text} from './text'
import actions from './actions/login'
import signUpActions from '../signup/actions/signup'
import {EmailLogin, FacebookLogin} from '../../state/login/actions'
import {connect} from 'react-redux'
import styles from './styles'
import compose from 'recompose/compose'
import yoursActions from '../yours/actions/yours'

class Login extends React.Component {

  handleSignInClick = (e) => {
    e.preventDefault()
    this.props.handleSignInClick()
  }

  handleSignUpClick = () => {
    this.props.handleSignUpClick()
    this.props.close()
  }

  render() {
    const {classes, fullScreen, open, close} = this.props
    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={close}
        maxWidth={'xs'}
        fullWidth
        classes={{
          paper: classes.Dialog,
        }}
      >
        <form noValidate autoComplete="off">
          <DialogContent>
            <IconButton className={classes.closeButton} onClick={close}><CloseIcon/></IconButton>
            <div style={{textAlign: 'center', marginTop: 80}}>
              <img src="/assets/logo.png" width={42} height={42} className={classes.logo} alt="logo"/>
            </div>
            <Grid container justify="center" direction="column" alignItems="center" className={classes.grid}>
              <Grid item xs={12} safariFix={true}>
                <Typography variant="headline">{text.hi}</Typography>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <Typography variant="body1">
                  <span style={{color: '#5B687C'}}>{text.iDontHaveAnAccount} </span>
                  <span className={classes.link} onClick={this.handleSignUpClick}>{text.signUpNow}</span>
                </Typography>
              </Grid>
              <Grid item xs={12} safariFix={true} style={{paddingTop: 45}}>
                <LoadingButton
                  variant="primary"
                  isLoading={this.props.facebookIsFetching}
                  className={classes.button}
                  component="div"
                  style={{backgroundColor: '#2160BE', width: 280}}
                >
                  <FacebookLoginButton
                    appId="1762190754086991"
                    fields="name,email"
                    reAuthenticate={false}
                    callback={this.props.handleFacebookSignIn}
                    cssClass={classes.facebookButton}
                    textButton={text.loginWithFacebook}
                    disableMobileRedirect={true}
                    tag="div"
                  />
                </LoadingButton>
              </Grid>
              {
                this.props.facebookError !== '' &&
                <Grid item xs={12} safariFix={true}>
                  <Typography className={classes.error}>{this.props.facebookError}</Typography>
                </Grid>
              }
              <Grid item xs={12} safariFix={true} style={{paddingTop: 20, paddingBottom: 10}}>
                <div className={classes.separator}>
                  <Divider className={classes.divider}/>
                  <Typography align="center" className={classes.o}> {text.or} </Typography>
                  <Divider className={classes.divider}/>
                </div>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <TextField
                  id="email"
                  label={text.email}
                  autoComplete="email"
                  className={classes.textField}
                  type="email"
                  onChange={e => this.props.setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <TextField
                  id="password"
                  type="password"
                  label={text.password}
                  autoComplete="current-password"
                  className={classes.textField}
                  onChange={e => this.props.setPassword(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <Typography className={classes.error}>{this.props.emailError}</Typography>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <LoadingButton
                  variant="primary"
                  onClick={this.handleSignInClick}
                  type="submit"
                  isLoading={this.props.emailIsFetching}
                  style={{width: 280}}
                >
                  {text.logIn}
                </LoadingButton>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <Typography variant="body1">
                  <Link to="/recuperar" className={classes.link}
                        onClick={() => {this.props.close()}}>{text.iForgotMyPassword}</Link>
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>
    )
  }
}

Login.propTypes = {
  email: PropTypes.string,
  password: PropTypes.string,
  emailError: PropTypes.string,
  setEmail: PropTypes.func,
  setPassword: PropTypes.func,
  handleSignInClick: PropTypes.func,
  emailIsFetching: PropTypes.bool,
  facebookIsFetching: PropTypes.bool,
  facebookError: PropTypes.string,
  handleFacebookSignIn: PropTypes.func,
}

const mapStateToProps = state => {
  const dialog = state.ui.loginComponent.login
  const login = state.ui.login
  return {
    email: login.emailLogin.email,
    password: login.emailLogin.password,
    emailError: login.emailLogin.error,
    emailIsFetching: login.emailLogin.isFetching,
    facebookIsFetching: login.facebookLogin.isFetching,
    facebookError: login.facebookLogin.error,
    open: dialog.get('open'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setEmail: email => dispatch(EmailLogin.setEmail(email)),
    setPassword: password => dispatch(EmailLogin.setPassword(password)),
    handleSignInClick: (email, password) => {
      dispatch(EmailLogin.login(email, password))
        .then(success => {
          if (success) dispatch(yoursActions.search())
        })
    },
    handleFacebookSignIn: response => dispatch(FacebookLogin.login(response)),
    handleSignUpClick: () => dispatch(signUpActions.open()),
    close: () => dispatch(actions.close()),
  }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(Login)
const StyledLogin = compose(withStyles(styles, {withTheme: true}), withMobileDialog())(Container)

export default StyledLogin



// WEBPACK FOOTER //
// ./src/sections/login/Login.js